<template>
  <div role="tabpanel" class="tab-pane fade" :class="activeClass" :id="id">
    <slot />
  </div>
</template>

<script>
export default {
  name: "tab-pane",
  props: {
    active: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    activeClass() {
      return this.active ? "in active" : "";
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Tabs/TabPane.vue